import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DashboardComponent } from './dashboard/dashboard.component';
import { AnalyticsComponent } from './analytics/analytics.component';
import { PlansComponent } from './plans/plans.component';
import { SettingsComponent } from './settings/settings.component';
import { VendorsComponent } from './vendors/vendors.component';
import { EmailSttingsComponent } from './email-sttings/email-sttings.component';
import { AccessLogsComponent } from './access-logs/access-logs.component';
import { CronJobComponent } from './cron-job/cron-job.component';

const routes: Routes = [
    { path: 'dashboard', component: DashboardComponent },
    { path: 'analytics', component: AnalyticsComponent },
    { path: 'plans', component: PlansComponent },
    { path: 'settings', component: SettingsComponent },
    { path: 'vendors', component: VendorsComponent },
    { path: 'email-settings', component: EmailSttingsComponent },
    { path: 'logs', component: AccessLogsComponent },
    { path: 'cron-job', component: CronJobComponent },
    { path: 'esign', loadChildren: () => import('./e-sign/e-sign.module').then(m => m.ESignModule) },
    { path: 'estamp', loadChildren: () => import('./e-stamp/estamp.module').then(m => m.EstampModule) },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class PagesRoutingModule { }
